const Main = () => import('../../pages/main')
export default {
	path: '/order',
	component: Main,
	meta: {
		sideNav: true
	},
	children: [
		{
			name: 'order',
			path: 'index',
			component: () => import('../../pages/Order'),

			meta: {
				requiresAuth: true,
				hidden: false,
				title: '订单管理',
				icon: 'icon-nav icon-nav-order',
			}
		}
	]
}
